<template>
   <div class="user-tabs">
       <el-tabs v-model="tabsKey" type="card" @tab-click="handleClick">
           <el-tab-pane label="查詢" name="search">
             <Search @addTabs="addUserTabs" @detailTabs="UserDetailTabs"   />
    
           </el-tab-pane>
           <el-tab-pane label="新增" name="addUser" v-if="isShowAdd">
              <Add  @removeAdd="removeUserTabs" />
           </el-tab-pane>
           <el-tab-pane label="詳細" name="detail" v-if="isShowDetail">
               <Detail :userKey ="userKey" @back="removeDetailTabs" @editTabs="userEditTabs"  />
           </el-tab-pane>
           <el-tab-pane label="編輯" name="edit" v-if="isShowEdit" >
               <Edit :userKey="userKey" @back="removeEditTabs" @outEdit="removeEditTabs" />
           </el-tab-pane>
       </el-tabs>
       
   </div>
         
</template>

<script>
import axios from 'axios'
import Search from './User/Search'
import Add from './User/Add'
import Detail from './User/Detail'
import Edit from './User/Edit'
    export default {
        name: 'User',
      
        data() {
            return {
                tabsKey: 'search',
                isShowAdd: false,
                isShowDetail: false,
                isShowEdit: false,
                userKey: ''
                   
            }
        },
        components: {
            Search,
            Add,
            Detail,
            Edit
        },
           methods: {
          
      addUserTabs(){
          this.isShowAdd = true
          this.tabsKey = 'addUser'
      },
      removeUserTabs(){
          this.isShowAdd = false
          this.tabsKey = 'search'
      },
      UserDetailTabs(userKey){
         this.userKey = userKey
          this.isShowDetail = true
          this.tabsKey = 'detail'
      },
      removeDetailTabs(){
          this.isShowDetail = false
          this.tabsKey = 'search'
      },
      userEditTabs(userKey){
          this.userKey = userKey
          this.isShowDetail = false
          this.isShowEdit = true
          this.tabsKey = 'edit'
      },
      removeEditTabs(){
          this.isShowEdit = false
          this.tabsKey = 'search'
      },
    
      wartchTabsKeys(){
          if (tabsKey == 'search') {
               this.removeUserTabs,
               this.removeDetailTabs
          }
      },
      handleClick(tab, event){
          if (tab.name == 'search') {
              this.removeEditTabs()
              this.removeUserTabs()
              this.removeDetailTabs()
          }
      }
      
           },
  
  
    }
</script>

<style lang="scss">
  .user-tabs {
          font-weight: bold;
         font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
  }
</style>